import { AbstractService } from "./ApiClient";
import { ApiRoutes } from "@typingsGenerator/ApiRoutes";
import AzureMarketplaceSubscriptionRegistrationDto = Cloud.RavenDB.Core.Dto.AzureMarketplace.AzureMarketplaceSubscriptionRegistrationDto;

export default class AzureMarketplaceService extends AbstractService {
    registerSubscription = async (dto: AzureMarketplaceSubscriptionRegistrationDto): Promise<void> => {
        const costs = await this.post<AzureMarketplaceSubscriptionRegistrationDto, void>(
            ApiRoutes.azureMarketplaceLandingPage.registerSubscription(),
            dto
        );
        return costs.data;
    };
}
